var _polygon, _path, _polygon2, _path2, _polygon3, _polygon4, _path3, _polygon5, _path4, _circle, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _circle2, _circle3, _polygon6, _rect, _path15, _circle4, _rect2, _path16, _circle5, _rect3, _path17, _circle6, _rect4, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _rect5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmptyCartAlternate(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    width: 888,
    height: 677.20705,
    viewBox: "0 0 888 677.20705",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "307.693 659.535 316.417 662.148 330.648 629.74 317.772 625.884 307.693 659.535",
    fill: "#ffb8b8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M462.32048,767.41626l17.18156,5.1462.00069.00021a11.43063,11.43063,0,0,1,7.66935,14.22912l-.10659.35581-28.13113-8.4259Z",
    transform: "translate(-156 -111.39648)",
    fill: "#2f2e41"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "390.602 666.663 399.153 663.528 391.13 629.055 378.51 633.682 390.602 666.663",
    fill: "#ffb8b8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M543.39769,776.06729l16.83948-6.17423.00068-.00025a11.43063,11.43063,0,0,1,14.6658,6.79715l.12785.34873L547.46038,787.1476Z",
    transform: "translate(-156 -111.39648)",
    fill: "#2f2e41"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "322.321 600.868 307.464 649.897 325.292 655.097 342.378 609.782 322.321 600.868",
    fill: "#2f2e41"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "369.121 612.011 382.493 658.068 401.064 649.154 387.693 606.068 369.121 612.011",
    fill: "#2f2e41"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M518.16217,731.71429a203.9796,203.9796,0,0,1-35.45752-3.27034l-.298-.06021v-11.3301l-6.78986-.75447,5.29979-18.92774c-2.47016-29.16024,1.03993-66.08934,2.17563-76.71865.26025-2.49265.43146-3.89132.43146-3.89132l5.95867-50.64955,9.97024-9.20308,4.52936,2.94751,8.40181,8.40145c9.766,24.0342,17.51548,46.661,17.56426,48.11483l32.75141,104.95321-.2209.156C551.10618,729.50964,533.77044,731.71429,518.16217,731.71429Z",
    transform: "translate(-156 -111.39648)",
    fill: "#3f3d56"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    points: "337.708 477.181 335.418 491.475 350.921 497.87 337.708 477.181",
    opacity: 0.2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M524.12819,556.834H488.28426a2.78413,2.78413,0,0,1-2.781-2.781v-15.45a20.703,20.703,0,0,1,41.40592,0v15.45A2.78412,2.78412,0,0,1,524.12819,556.834Z",
    transform: "translate(-156 -111.39648)",
    fill: "#2f2e41"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 354.16363,
    cy: 429.32816,
    r: 15.17868,
    fill: "#ffb8b8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M531.807,540.148H509.88932l-.22481-3.14673-1.12374,3.14673h-3.37485l-.4454-6.23672-2.22727,6.23672h-6.53018v-.309a16.39537,16.39537,0,0,1,16.37682-16.377H515.43a16.39549,16.39549,0,0,1,16.377,16.377Z",
    transform: "translate(-156 -111.39648)",
    fill: "#2f2e41"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M509.70994,559.718a2.84058,2.84058,0,0,1-.49216-.04345l-16.04911-2.83169V530.31841h17.667l-.4374.51c-6.08554,7.09733-1.50079,18.60574,1.77373,24.834a2.73982,2.73982,0,0,1-.21772,2.90894A2.76982,2.76982,0,0,1,509.70994,559.718Z",
    transform: "translate(-156 -111.39648)",
    fill: "#2f2e41"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M538.02851,623.82967h-8.79718a1.1313,1.1313,0,0,1-1.13-1.02492l-1.7609-18.04893h14.579l-1.7609,18.04871A1.13131,1.13131,0,0,1,538.02851,623.82967Z",
    transform: "translate(-156 -111.39648)",
    fill: "#228be6"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M540.89615,607.02652H526.36369a1.13668,1.13668,0,0,1-1.13534-1.13535v-2.72484a1.13668,1.13668,0,0,1,1.13534-1.13534h14.53246a1.13668,1.13668,0,0,1,1.13535,1.13534v2.72484A1.13669,1.13669,0,0,1,540.89615,607.02652Z",
    transform: "translate(-156 -111.39648)",
    fill: "#2f2e41"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M483.8924,616.06358l0,0a27.88129,27.88129,0,0,0,33.46807,6.76478l3.30359-1.635Z",
    transform: "translate(-156 -111.39648)",
    opacity: 0.2
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M536.71057,612.5695a6.96579,6.96579,0,0,0-10.67635.32242l-15.32558-4.30242-4.88606,8.67563,21.728,5.77187a7.00355,7.00355,0,0,0,9.16-10.4675Z",
    transform: "translate(-156 -111.39648)",
    fill: "#ffb8b8"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M500.13852,622.19727c-7.28644.00072-17.14532-4.27146-28.84884-12.546a5.73089,5.73089,0,0,1-2.4134-3.92759c-.86328-5.46918,4.4715-12.863,4.99455-13.57174l5.60811-15.40061c.06456-.25028,1.87184-6.91355,6.409-9.28432a7.43841,7.43841,0,0,1,6.21386-.26479c8.6423,3.147,1.894,27.44817.96757,30.63508l11.45016,5.38938,7.27119,4.6349,9.95773,1.04175-2.70358,12.51186-15.12275.34024A15.43364,15.43364,0,0,1,500.13852,622.19727Z",
    transform: "translate(-156 -111.39648)",
    fill: "#3f3d56"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M1043.67468,508.05561A98.57951,98.57951,0,1,0,854.454,546.865c-.09637-.10718-.196-.21149-.29193-.31909a98.66626,98.66626,0,0,0,17.95428,27.78283c.0224.02466.04541.04871.06788.07337.60559.66,1.21466,1.31659,1.83782,1.9599a98.28006,98.28006,0,0,0,69.52936,30.25354l-3.33105,180.9292h10.29126l-2.08283-119.41541,14.88678-7.83758-2.27093-4.31354-12.711,6.692-.97791-56.06378A98.57812,98.57812,0,0,0,1043.67468,508.05561Z",
    transform: "translate(-156 -111.39648)",
    fill: "#e6e6e6"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M751.0871,460.00819a115.52648,115.52648,0,1,0-221.74982,45.4812c-.113-.12561-.22968-.24784-.3421-.37393a115.62807,115.62807,0,0,0,21.04083,32.559c.02625.02893.05322.05706.07959.086.70972.7735,1.42346,1.543,2.15375,2.29682a115.17561,115.17561,0,0,0,81.48224,35.45447l-3.90375,212.033h12.06042l-2.44091-139.94428,17.446-9.185-2.66138-5.05505-14.89618,7.84247-1.146-65.70178A115.52494,115.52494,0,0,0,751.0871,460.00819Z",
    transform: "translate(-156 -111.39648)",
    fill: "#e6e6e6"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M419.25891,414.8147A131.46683,131.46683,0,1,0,166.912,466.57142c-.12855-.14295-.26138-.282-.38931-.42551a131.58166,131.58166,0,0,0,23.944,37.05149c.02989.03289.06059.065.09055.09787.80763.88021,1.61988,1.75582,2.45091,2.61373a131.0676,131.0676,0,0,0,92.72516,40.3465L281.291,787.54475h13.72454L292.23788,628.291,312.091,617.83869l-3.02856-5.75256-16.95154,8.92456-1.30411-74.76727A131.465,131.465,0,0,0,419.25891,414.8147Z",
    transform: "translate(-156 -111.39648)",
    fill: "#e6e6e6"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 756.68549,
    cy: 85.97574,
    r: 85.97575,
    fill: "#ff6584"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 245.55884,
    cy: 187.61628,
    r: 172.3117,
    fill: "#228be6"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M274.32944,183.92207A172.32513,172.32513,0,0,0,561.45166,366.29173,172.32654,172.32654,0,1,1,274.32944,183.92207Z",
    transform: "translate(-156 -111.39648)",
    opacity: 0.2,
    style: {
      isolation: "isolate"
    }
  }), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    points: "246.032 187.616 246.506 187.616 255.027 676.148 237.038 676.148 246.032 187.616",
    fill: "#3f3d56"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 401.08538,
    y: 564.58106,
    width: 32.19013,
    height: 8.5209,
    transform: "translate(-372.96557 148.44822) rotate(-27.76587)",
    fill: "#3f3d56"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M665.11523,782.975s.62171-13.02673,13.3664-11.51257",
    transform: "translate(-156 -111.39648)",
    fill: "#3f3d56"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 505.51413,
    cy: 652.80328,
    r: 6.37865,
    fill: "#228be6"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 504.47623,
    y: 663.54456,
    width: 1.80054,
    height: 12.60376,
    fill: "#3f3d56"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M223.08289,781.17445s.62168-13.02674,13.36641-11.51258",
    transform: "translate(-156 -111.39648)",
    fill: "#3f3d56"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 63.48181,
    cy: 651.00275,
    r: 6.37865,
    fill: "#228be6"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 62.44391,
    y: 661.74402,
    width: 1.80054,
    height: 12.60376,
    fill: "#3f3d56"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M327.51416,782.07471s.6217-13.02673,13.36642-11.51257",
    transform: "translate(-156 -111.39648)",
    fill: "#3f3d56"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 167.91309,
    cy: 651.90302,
    r: 6.37865,
    fill: "#228be6"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 166.87518,
    y: 662.64429,
    width: 1.80054,
    height: 12.60376,
    fill: "#3f3d56"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M605.24329,194.695l12.79486-10.23341c-9.93976-1.09662-14.02381,4.3243-15.69525,8.615-7.76532-3.22446-16.21882,1.00135-16.21882,1.00135l25.6001,9.29375A19.37211,19.37211,0,0,0,605.24329,194.695Z",
    transform: "translate(-156 -111.39648)",
    fill: "#3f3d56"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M799.827,298.93629l12.7948-10.23343c-9.93976-1.09662-14.02381,4.32431-15.69526,8.615-7.76532-3.22446-16.21881,1.00134-16.21881,1.00134l25.6001,9.29376A19.37241,19.37241,0,0,0,799.827,298.93629Z",
    transform: "translate(-156 -111.39648)",
    fill: "#3f3d56"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M589.95459,387.88883l12.7948-10.23343c-9.93976-1.09662-14.0238,4.32431-15.69525,8.615-7.76532-3.22445-16.21881,1.00138-16.21881,1.00138l25.60009,9.29373A19.37244,19.37244,0,0,0,589.95459,387.88883Z",
    transform: "translate(-156 -111.39648)",
    fill: "#3f3d56"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M839.65527,787.70325s.62171-13.02673,13.3664-11.51257",
    transform: "translate(-156 -111.39648)",
    fill: "#3f3d56"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M719.91943,787.70325s.62171-13.02673,13.3664-11.51257",
    transform: "translate(-156 -111.39648)",
    fill: "#3f3d56"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M283.2887,787.70325s.6217-13.02673,13.36642-11.51257",
    transform: "translate(-156 -111.39648)",
    fill: "#3f3d56"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M893.67145,787.70325s.6217-13.02673,13.36639-11.51257",
    transform: "translate(-156 -111.39648)",
    fill: "#3f3d56"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M868.46387,787.70325s.6217-13.02673,13.36639-11.51257",
    transform: "translate(-156 -111.39648)",
    fill: "#3f3d56"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M816.465,787.70325s-.62171-13.02673-13.3664-11.51257",
    transform: "translate(-156 -111.39648)",
    fill: "#3f3d56"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M609.40308,787.70325s-.62171-13.02673-13.3664-11.51257",
    transform: "translate(-156 -111.39648)",
    fill: "#3f3d56"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M437.4516,787.70325s-.6217-13.02673-13.36643-11.51257",
    transform: "translate(-156 -111.39648)",
    fill: "#3f3d56"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M254.69688,787.70325s-.6217-13.02673-13.36641-11.51257",
    transform: "translate(-156 -111.39648)",
    fill: "#3f3d56"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M947.90442,787.70325s-.62171-13.02673-13.3664-11.51257",
    transform: "translate(-156 -111.39648)",
    fill: "#3f3d56"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M870.4812,788.60352s-.6217-13.02673-13.36639-11.51257",
    transform: "translate(-156 -111.39648)",
    fill: "#3f3d56"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    y: 674.60352,
    width: 888,
    height: 2,
    fill: "#3f3d56"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyCartAlternate);
export default __webpack_public_path__ + "static/media/empty-cart-alternate.c0186c144eef1c51a0787fca7fe99aee.svg";
export { ForwardRef as ReactComponent };